<a
  class="element"
  [attr.href]="url"
  [attr.target]="target"
  [ngClass]="{ footer: isFooter, contain_icon: showIconMore }"
  >
    {{ text }}
    <!-- OK -->
    <app-icon
        icon="expend_more"
        *ngIf="showIconMore"
    >
    </app-icon>
</a>
